export const USDC_MINT = process.env.USDC_MINT || "EPjFWdd5AufqSSqeM2qN1xzybapC8G4wEGGkZwyTDt1v";
export const URL_MARKETS = process.env.REACT_APP_API_BASE_URL || 'https://testnet-api-internal.raiserdapp.com';
export const PROGRAM_DEX = process.env.PROGRAM_DEX || "B2q9rJsuhCkvMNXLjXaH9qf5cQm7fwNv9ZHkLtT64XEn";

export const CREDORA_CLIENTID = process.env.CREDORA_CLIENTID || "Uq7hGEsrXE9lrRFDuYzMA1PYx"

export const CREODORA_CLIENTSECRET = process.env.CREODORA_CLIENTSECRET || "1Ay567Hd17US9AdKQNaExEXSB"
